module.exports = __webpack_public_path__ + "static/img/arthroscopy-01.07288f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/arthroscopypic/arthroscopy-01.jpg
// module id = g9X8
// module chunks = 52